import { ActionIcon, Flex, Title } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useHistory } from 'react-router-dom';

export default function CatalogEditCreateHeader({
  title,
  hideTitle = false
}: {
  title: string;
  hideTitle?: boolean;
}) {
  const history = useHistory();
  if (hideTitle) return <></>;
  return (
    <Flex align="center" mb={20}>
      <ActionIcon variant="transparent" aria-label="Regresar" onClick={() => history.goBack()}>
        <IconArrowLeft />
      </ActionIcon>
      <Title order={1} lineClamp={1}>
        {title}
      </Title>
    </Flex>
  );
}
